/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { Box, Button, MessageIcon } from '@bottlebooks/gatsby-theme-base';
import '@reach/dialog/styles.css';
import { Trans } from '@lingui/macro';
import React from 'react';
import { jsx } from 'theme-ui';
import BookAMeetingDialog from './BookAMeetingDialog';
import BookAMeetingConfirmation from './BookAMeetingConfirmation';

/**
 * Ability to book a meeting with an exhibitor
 * @param {object} props
 * @param {object} props.contact
 * @param {object} props.exhibitor
 * @param {string} [props.collectionId]
 * @param {string} [props.companyId]
 * @param {'DISABLED' | 'ENABLED'} [props.contactButtonVisibility]
 * @param {'DISABLED' | 'OPTIONAL' | 'REQUIRED'} [props.contactButtonAuthenticationMode]
 * @returns
 */
export default function BookAMeetingButton({
  contact,
  exhibitor,
  collectionId,
  companyId,
  contactButtonVisibility = 'DISABLED',
  contactButtonAuthenticationMode = 'OPTIONAL',
  ...rest
}) {
  const [visibleDialogName, toggleDialog] = React.useState('');

  // const { isLoggedIn, profile } = useAuth();
  // Don't render button at all if AUTH0 is not active
  if (contactButtonVisibility === 'DISABLED') return null;

  // const auth0Enabled = Boolean(process.env.AUTH0_DOMAIN);

  // Force user to log in before sending meeting request
  // if (auth0Enabled && contactButtonAuthenticationMode === 'REQUIRED') {
  //   if (!isLoggedIn) return <BookAMeetingLoginButton {...rest} />;
  //   if (isLoggedIn && !profile)
  //     // Handle situation where user is logged in, but profile cannot be retrieved
  //     return <BookAMeetingLoginButton {...rest} />;
  // }
  if (!collectionId)
    return (
      <Box sx={{ backgroundColor: 'red' }}>CollectionId not passed in</Box>
    );
  return (
    <React.Fragment>
      <Button
        onClick={() => toggleDialog('form')}
        variant="primary"
        sx={{ paddingX: 3, paddingY: 2, alignItems: 'center' }}
        {...rest}
      >
        <MessageIcon
          size="small"
          sx={{ marginRight: 2, color: 'currentColor' }}
        />
        <Trans>Send message</Trans>
      </Button>
      {visibleDialogName === 'form' && (
        <BookAMeetingDialog
          collectionId={collectionId}
          exhibitor={exhibitor}
          contact={contact}
          companyId={companyId}
          onDismiss={() => toggleDialog('')}
          onSubmit={() => toggleDialog('success')}
        />
      )}
      {visibleDialogName === 'success' && (
        <BookAMeetingConfirmation
          contact={contact}
          onDismiss={() => toggleDialog('')}
        />
      )}
    </React.Fragment>
  );
}
